import {
    Component, Input, OnInit, HostListener, ViewChild, ElementRef,
    OnChanges, Output, EventEmitter
} from '@angular/core';
import { ModalService } from './modal.service';
import { ModalConfig } from 'app/shared/models/modalConfig.model';
import { DomHelper } from '@sc/pas-common';
import { KeyCode } from 'app/shared/models/keycode';

@Component({
    selector: 'sc-modal-2',
    styleUrls: ['./modal.component.scss'],
    templateUrl: './modal.component.html'

})

export class ModalComponent2 implements OnInit, OnChanges {
    buttonsBox: any;
    public contentPadding: string;
    public sizeClass: string;
    @Input() blocking = false;
    @Input() id;
    @Input() options: ModalConfig = new ModalConfig();
    @Output() onModalClose: EventEmitter<boolean> = new EventEmitter();
    @ViewChild('modal', { static: true }) modalContainer = ElementRef;
    isOpen = false;
    isRegistered = false;

    @HostListener('keyup')
    onMouseEnter(event) {
        this.keyup(event);
    }

    constructor(private modalService: ModalService, private dom: DomHelper) {
    }

    ngOnChanges(change) {
        if (this.modalContainer && this.modalContainer['nativeElement']) {
            this.buttonsBox = this.modalContainer['nativeElement'].getElementsByClassName('modal__buttonsBox')[0];
            this.buttonsBox.innerHTML = '';
            if (this.options && this.options.buttons && this.buttonsBox) {

                if (this.options.buttons.length) {
                    this.dom.addClass(this.buttonsBox, 'modal__buttonsBox-' + this.options.buttons.length);
                }

                this.options.buttons.forEach((b) => {
                    const btn = document.createElement('button');
                    this.dom.addClass(btn, 'modal__button btn');
                    if (b.className) {
                        this.dom.addClass(btn, b.className);
                    }
                    if (b.id) {
                        btn.id = b.id
                    }
                    if (b.default || this.options.buttons.length === 1) {
                        this.dom.addClass(btn, 'default');
                    }

                    btn.innerHTML = b.text;

                    if (b.cancel) {
                        btn.onclick = () => {
                            this.close()
                        }
                    } else {
                        if (b.action) {
                            btn.onclick = b.action;
                        }
                    }
                    this.buttonsBox.append(btn)
                });
            }
            if (!this.isRegistered) {
                this.isRegistered = true;
                this.isOpen = false;
                this.modalService.registerModal(this);
            } else {
                this.isOpen = true;
            }
        }

        this.sizeClass = (this.options && this.options.size) ? `modal--${this.options.size}` : '';
        this.contentPadding = (this.options && this.options.closeButton) ? '53px' : '38px';
    }

    ngOnInit() {

    }

    close(checkBlocking = false): void {
        if (this.id && !checkBlocking) {
            this.onModalClose.emit(true);
            this.modalService.close(this.id, checkBlocking);
        }
    }

    private keyup(event: KeyboardEvent): void {
        if(event) {
            if (event.keyCode === KeyCode.Escape) {
                this.modalService.close(this.id, true);
            }
            if (event.keyCode === KeyCode.Enter) {
                const defaultBtn = this.buttonsBox[0].getElementsByClassName('default');
                defaultBtn[0].click()
            }
        }
    }
}
